import React from "react";
import { Paper, Typography, TextField, Button, Box } from "@mui/material";

const SettingspageMain = () => (
  <div style={{ padding: 24 }}>
    <Typography variant="h5" gutterBottom>
      إعدادات النظام
    </Typography>
    <Paper sx={{ p: 3, maxWidth: 400 }}>
      <Box component="form" noValidate autoComplete="off">
        <TextField
          fullWidth
          label="اسم النظام"
          defaultValue="نظام الإدارة"
          margin="normal"
        />
        <TextField
          fullWidth
          label="البريد الإلكتروني للدعم"
          defaultValue="support@email.com"
          margin="normal"
        />
        <Button variant="contained" color="primary" sx={{ mt: 2 }}>
          حفظ التغييرات
        </Button>
      </Box>
    </Paper>
  </div>
);

export default SettingspageMain;
